
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";

import {CONST} from '../../environments/environment'

// 1ページあたりの表示件数
export const RESULT_LIMIT = 20;
// 「New」を表示するのは何日前までかを定義
export const NEW_NOTICE_DATE = 31;

// お知らせ一覧取得APIの実行用
export async function executeGetNoticeList(pageNumber){
	let session = await fetchAuthSession();
	let api_name = CONST.API_NAME;
	let path = CONST.API_PATH.NOTICE;
	let my_init = {
		headers: {
			Authorization: session.tokens?.idToken?.toString()
		},
		queryParams: {
			// 現在はユーザーを識別していないため、トークンは不要
			// accessToken: session.getAccessToken().getJwtToken()
			resultLimit: RESULT_LIMIT,
			pageNumber: pageNumber
		}
	};
	let response = await get({
		apiName: api_name,
		path,
		options: my_init
    }).response;
    response = await response.body.json();
	if ("errorMessage" in response) {
		throw response;
	}
	return response
}

// ### お知らせ一覧を表示するコンポーネント
